/* ENGORI 25.09.2026 (BFSG-05): Die Fokusfalle des Themes (getFocusableElements aus main.js)
   zählt auch unsichtbare Elemente mit. Nur Elemente mit Layout-Box bleiben in der Tab-Runde.
   Nach Updates der externen main.js neu testen. */
(function(){var o=window.getFocusableElements;if(typeof o!=='function')return;window.getFocusableElements=function(c){return Array.prototype.filter.call(o(c),function(e){return e.getClientRects().length>0;});};})();
